export default __webpack_public_path__ + "static/top_mv_tab-0d3e039d2717a361503dc50d995f7982.jpg";